var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"204176083cc84a0f62f7c673dc0510bf36443832"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["elo-cabinets@ablefy"]={id:"204176083cc84a0f62f7c673dc0510bf36443832"};
      